import { ProgramStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateProgramStatus: (
  fetchContext: FetchContext,
  programId: number,
  programStatus: ProgramStatus,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, programStatus, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/status`,
  {
    method: 'PUT',
    body: JSON.stringify(programStatus),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update program status'));
